export default __webpack_public_path__ + "static/media/domain-section.09982154.svg";